import React, { useEffect } from 'react';
import { Stack, CommandButton } from '@fluentui/react';
import {
    MicIcon,
    MicOffIcon,
    CallVideoIcon,
    CallVideoOffIcon,
    CallEndIcon,
    EyeFriendlierIcon,
    EyeSlashIcon,
    CallControlCloseTrayIcon,
    CallControlPresentNewIcon
} from '@fluentui/react-icons-northstar';
import {
    controlButtonStyle,
    endCallButtonStyle,
    endCallButtonTextStyle,
    mediaControlStyles,
    fullWidth,
    displayNoneStyle,
    hiddenStyle,
    controlButtonDisabledStyle
} from './styles/MediaControls.styles';
import { ParticipantStream } from 'core/reducers';
import {
    IsCandidateMode,
    IsInterlocutorMode,
    IsHiddenMode,
    IsProctorMode,
    IsProctorCameraEnabled
} from 'Utils/Utils';
import { ButtonstConstants } from '../core/constants';
export interface MediaControlsProps {
    micActive: boolean;
    screenShareActive: boolean;
    activeScreenShareStream: ParticipantStream | undefined;
    cameraActive: boolean;
    cameraPermission: string;
    microphonePermission: string;
    localVideoRendererIsBusy: boolean;
    compressedMode: boolean;
    onMicChange(): void;
    onCameraChange(isLocalClick: boolean): void;
    startCamera(): void;
    stopCamera(): void;
    onScreenShareChange(): void;
    onEndCallClick(): void;
    isLocalScreenShareSupportedInBrowser(): boolean;
    onLocalPreviewClick(): void;
    localPreviewActive: boolean;
    cameraDisabled: boolean;
}

export default (props: MediaControlsProps): JSX.Element => {
    const cameraActive = props.cameraPermission === 'Denied' ? false : props.cameraActive;
    const cameraDisabled = props.cameraDisabled;
    const cameraOnClick = props.cameraPermission !== 'Denied' ? props.onCameraChange : undefined;
    const startCamera = props.cameraPermission !== 'Denied' ? props.startCamera : undefined;
    const stopCamera = props.cameraPermission !== 'Denied' ? props.stopCamera : undefined;
    const micActive = props.microphonePermission === 'Denied' ? false : props.micActive;
    const micDisabled = props.microphonePermission === 'Denied' ? false : (IsCandidateMode() || IsHiddenMode());
    const micOnClick = props.microphonePermission !== 'Denied' ? props.onMicChange : undefined;
    //const localPreviewDisabled = props.cameraPermission === 'Denied';
    const localPreviewActive = props.localPreviewActive;
    const localPreviewOnClick = props.onLocalPreviewClick;

    const screenShareDisabled = !!props.activeScreenShareStream;
    let autoStartShareSeconds = 20;
    const maxAutoStartShareSeconds = 9999999;
    const leavebuttontext = ButtonstConstants.LeaveCallButtonText;
    const triggerHiddenVolumeUp = () => {
        console.log('SignalR: triggered the button triggerHiddenVolumeUp');
    };
    const triggerHiddenVolumeDown = () => {
        console.log('SignalR: triggered the button triggerHiddenVolumeDown');
    };

    useEffect(() => {
        if (IsCandidateMode()) {
            var timeout = setTimeout(function () {
                if (!props.screenShareActive) {
                    try {
                        props.onScreenShareChange();
                        autoStartShareSeconds = maxAutoStartShareSeconds;
                    } catch (error) {
                        console.error(error);
                    }
                }
            }, autoStartShareSeconds * 1000);
            return () => clearTimeout(timeout);
        }

        return () => null;    
    }, [IsCandidateMode, props.screenShareActive, props.onScreenShareChange]);

    return (
        <Stack className={mediaControlStyles}>

            <CommandButton
                id={"triggerHiddenVolumeUp"}
                onClick={triggerHiddenVolumeUp}
                hidden={true}
                className={displayNoneStyle}
            >
            </CommandButton>
            <CommandButton
                id={"triggerHiddenVolumeDown"}
                onClick={triggerHiddenVolumeDown}
                hidden={true}
                className={displayNoneStyle}
            >
            </CommandButton>
            <CommandButton
                id={"CameraButtonId"}
                hidden={true}
                onClick={() => cameraOnClick?.(false)}
                className={displayNoneStyle}
            >
            </CommandButton>
            <CommandButton
                id={"startCameraBtn"}
                hidden={true}
                onClick={startCamera}
                className={displayNoneStyle}
            >
            </CommandButton>
            <CommandButton
                id={"stopCameraBtn"}
                hidden={true}
                onClick={stopCamera}
                className={displayNoneStyle }
            >
            </CommandButton>

            {!(IsInterlocutorMode() || IsProctorMode()) && props.isLocalScreenShareSupportedInBrowser() && (
                <CommandButton
                    id={"screenShareButton"}
                    disabled={screenShareDisabled || IsHiddenMode() || (IsCandidateMode() && props.screenShareActive )}
                    onClick={function (event) {
                        autoStartShareSeconds = maxAutoStartShareSeconds;
                        props.onScreenShareChange();
                        }}
                    className={IsHiddenMode() ? hiddenStyle : (screenShareDisabled ? controlButtonDisabledStyle : controlButtonStyle)}
                >
                    <div className={fullWidth}>
                        {props.screenShareActive ? (
                           
                            <CallControlCloseTrayIcon size="medium" />
                        ) : (
                            <CallControlPresentNewIcon
                                size="medium" />
                        )}
                        
                    </div>
                </CommandButton>
            )}
            {(!(IsProctorMode() && !IsProctorCameraEnabled())) && (
            <CommandButton                
                onKeyDownCapture={(e): void => {
                    if (e.keyCode === 13 && props.localVideoRendererIsBusy) {
                        e.preventDefault();
                    }
                }}
                disabled={cameraDisabled}
                onClick={() => cameraOnClick?.(true)}
                className={IsHiddenMode() ? hiddenStyle : controlButtonStyle}
            >
                <div className={fullWidth}>
                    {cameraActive ? <CallVideoIcon size="medium" /> : <CallVideoOffIcon size="medium" />}
                </div>
            </CommandButton>
            )}
            <CommandButton
                onClick={micOnClick}
                disabled={micDisabled}
                className={IsHiddenMode() ? hiddenStyle : controlButtonStyle}>
                <div className={fullWidth}>
                    {micActive ? <MicIcon size="medium" /> : <MicOffIcon size="medium" />}
                </div>
            </CommandButton>
            {(!(IsProctorMode() && !IsProctorCameraEnabled())) && (
                <CommandButton onClick={localPreviewOnClick} disabled={/*localPreviewDisabled ||*/ IsHiddenMode()} className={controlButtonStyle}>
                    <div className={IsHiddenMode() ? hiddenStyle : fullWidth}>{localPreviewActive ? <EyeFriendlierIcon size="medium" /> : <EyeSlashIcon size="medium" />}</div>
                </CommandButton>
            )}
            {!IsCandidateMode()
                ?
                (<CommandButton
                    onClick={props.onEndCallClick}
                    className={props.compressedMode ? controlButtonStyle : endCallButtonStyle}
                    id={"LeaveButton"}
                >
                    <div className={fullWidth}>
                        <CallEndIcon size="medium" />
                        {!props.compressedMode && <span className={endCallButtonTextStyle}>{leavebuttontext}</span>}
                    </div>
                </CommandButton>)
                :
                (<CommandButton
                    onClick={props.onEndCallClick}
                    className={displayNoneStyle}
                    id={"LeaveButton"}
                >
                    <div className={fullWidth}>
                        <CallEndIcon size="medium" />
                        {!props.compressedMode && <span className={endCallButtonTextStyle}>{leavebuttontext}</span>}
                    </div>
                </CommandButton>)
            }
        </Stack>
    );
};